import api from "./api";

export const getSubscriptionPlans = async () => {
  const response = await api.get("/subscriptions/plans");
  return response.data;
};

export const createCheckoutSession = async (planType) => {
  const response = await api.post("/subscriptions/create-checkout-session", {
    plan_type: planType,
  });
  return response.data;
};

export const getCurrentSubscription = async () => {
  const response = await api.get("/subscriptions/current");
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.post("/subscriptions/cancel");
  return response.data;
};
